import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TeachrShowInfo from "../../Objects/models/TeachrShowInfo";
import Teachr_Repository from "../../Repositories/Teachr_Repository";
import { userTeachrSetAccountAction } from "../../Redux/Actions/UserActions";
import { getActiveBrandConfig, getActivePrestationBrandConfig } from "../../config/environment.config";
import DialogLayout from "../DialogLayout";
import useTailwindBrand from "../../Theme/useTailwindBrand";
import { SHOW_INFO } from "../../Redux/Reducers/MessageReducers";
import Teachr from "../../Objects/models/Teachr";

export interface TeachrInfoDialogHandle {
    open: () => void;
    openParam: () => void;
}

interface TeachrInfoDialogProps {
    teachr: Teachr;
    // onOpenParam: () => void;
}

const TeachrInfoDialog = forwardRef<TeachrInfoDialogHandle, TeachrInfoDialogProps>(({ teachr }, ref) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { classes } = useTailwindBrand();
    const [open, setOpen] = useState(false);
    const [load, setLoad] = useState(false);

    const handleOpenParam = () => {
        if (!teachr?.address) {
            navigate(`/${getActiveBrandConfig()}/tableau-de-bord/parametre`, { state: { step: 1 } })
            dispatch({ type: SHOW_INFO, payload: `Merci de renseigner votre adresse postale afin de pouvoir déclarer votre ${getActivePrestationBrandConfig()}` })
        } else {
            navigate(`/${getActiveBrandConfig()}/tableau-de-bord/parametre`, { state: { step: 2 } })
            dispatch({ type: SHOW_INFO, payload: `Merci de renseigner votre IBAN et votre BIC afin de pouvoir déclarer votre ${getActivePrestationBrandConfig()}` })
        }
    }

    useImperativeHandle(ref, () => ({
        open: () => setOpen(true),
        openParam: () => handleOpenParam()
    }));


    const handleClose = () => setOpen(false);

    const handleUpdateInfo = () => {
        const showInfo = new TeachrShowInfo(true);
        if (teachr?.id) {
            const updateTeachr = { ...teachr };
            setLoad(true);
            Teachr_Repository.teachrShowInfo(teachr.id, showInfo)
                .then(() => {
                    updateTeachr.isShowInfos = true;
                    const serializedTeachr = JSON.parse(JSON.stringify(updateTeachr));
                    dispatch(userTeachrSetAccountAction(serializedTeachr));
                    dispatch({ type: 'SET_TEACHR_INFO', payload: { teachr: serializedTeachr } });
                    setLoad(false);
                    handleClose();
                    if (!teachr?.iban) {
                        handleOpenParam();
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setLoad(false);
                })
                .finally(() => {
                    setLoad(false);
                });
        }
    };

    const handleSubmit = () => {
        if (teachr?.iban) {
            handleUpdateInfo();
            navigate(`/${getActiveBrandConfig()}/tableau-de-bord/${getActivePrestationBrandConfig()}/declarer`);
        } else {
            handleUpdateInfo();
        }
    };

    const body = (
        <div>
            <p>
                Il se peut que certaines banques bloquent les prélèvements de divers émetteurs. <br />
                Afin d'éviter cela, nous vous conseillons de transmettre à vos clients le numéro de créancier et l'émetteur des prélèvements URSSAF afin qu'ils puissent prévenir leurs banques.
            </p>
            <div className="flex gap-x-4 mt-6">
                <div>
                    <p>Numéro créancier ICS :</p>
                    <div className={`${classes.primaryText} bg-[#F2F5FB] p-2`}>
                        FR55HOM143065
                    </div>
                </div>
                <div>
                    <p>Émetteur :</p>
                    <div className={`${classes.primaryText} bg-[#F2F5FB] p-2`}>
                        URSSAF RHONE-ALPES CNCESU
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <DialogLayout
            title="Information client"
            text={body}
            valid="C'est compris"
            open={open}
            load={load}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            customCancel="hidden"
            customValid="col-span-1"
        />
    );
}
);

TeachrInfoDialog.displayName = "TeachrInfoDialog";
export default TeachrInfoDialog;
